import { render, staticRenderFns } from "./form-ocr-popup.vue?vue&type=template&id=1c46c9d7&scoped=true"
import script from "./form-ocr-popup.vue?vue&type=script&lang=js"
export * from "./form-ocr-popup.vue?vue&type=script&lang=js"
import style0 from "./form-ocr-popup.vue?vue&type=style&index=0&id=1c46c9d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c46c9d7",
  null
  
)

export default component.exports